var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa3SeaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327.486,
    height: 159.906,
    viewBox: "0 0 327.486 159.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sofa_3_seater-icon",
    "data-name": "sofa 3 seater-icon",
    transform: "translate(-7921 2982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M8015.243-2982h193.166c1.973.418,3.966.764,5.915,1.269,5.491,1.424,9.851,4.409,11.35,10.083a51.922,51.922,0,0,1,1.853,12.549c.2,17.906.092,35.814.083,53.722,0,.709-.123,1.417-.187,2.1H7996.206c0-20.357-.181-40.492.105-60.621.091-6.405,1.968-12.7,8.317-15.907C8007.876-2980.44,8011.687-2980.968,8015.243-2982Z",
    transform: "translate(-27.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M7921-2836.651v-69.719c1.438-4.339,3.549-8.206,7.608-10.667,10.817-6.559,24.111.981,24.309,13.944.184,12.041.042,24.086.045,36.13v3.273h263.563v-3.594c0-11.937-.129-23.875.043-35.81.173-12.032,11.672-19.624,22.324-14.971,5.209,2.276,7.881,6.579,9.594,11.695v69.719c-1.68,4.856-4.028,9.447-9.088,11.262a32.35,32.35,0,0,1-10.894,1.623c-3.294-.015-4.121.925-4.047,4.132.155,6.688-.156,13.387-.277,20.081h-23.666v-23.856H7968.972v23.856h-23.666c-.12-1.152-.338-2.3-.344-3.458-.036-5.969-.087-11.94.019-17.907.037-2.065-.607-2.8-2.726-2.772a41.109,41.109,0,0,1-9.21-.54C7926.427-2825.681,7923.006-2830.556,7921-2836.651Z",
    transform: "translate(0 -22.542)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa3SeaterIcon);
export default __webpack_public_path__ + "static/media/sofa 3 seater-icon.4c2c1f778cfb113a7437344685984561.svg";
export { ForwardRef as ReactComponent };